import { Component, computed, input } from '@angular/core';

import { MyBetsBet, MyBetsListContext } from '../../../my-bets-base/models/my-bets-viewmodels';
import { MyBetsEventModel } from '../../models/my-bets-event.model';
import { BetMarketInfo, PlayerStatInfo } from '../../models/my-bets-visualization-types';

@Component({
    template: '',
    standalone: false,
})
export abstract class VisualizationBaseComponent {
    event = input.required<MyBetsEventModel>();
    bet = input.required<MyBetsBet>();
    statsData = input.required<PlayerStatInfo>();
    myBetsListContext = input.required<MyBetsListContext>();
    isCashedOut = input<boolean>(false);
    betMarketInfo = input.required<BetMarketInfo>();

    currentStatValue = computed(() => {
        return this.statsData().player1CurrStat + this.statsData().player2CurrStat;
    });
}
